import clsx from 'clsx';
import { AnimatePresence, LayoutGroup, motion } from 'motion/react';
import { useRef } from 'react';

import { useToastStore } from '#state/stores/toast-store.js';

export function ToastStack() {
	const toasts = useToastStore((state) => state.toasts);

	const scrollContainerRef = useRef<HTMLDivElement>(null);

	return (
		// `pointer-events-none` lets the user interact with the page contents underneath the toast stack, around the toasts.
		<div className='pointer-events-none absolute right-0 bottom-0 isolate'>
			<motion.div
				ref={scrollContainerRef}
				layoutScroll
				className='flex h-[max(50dvh,30rem)] w-90 flex-col-reverse gap-2 overflow-y-scroll px-6 pb-6 [scrollbar-width:none]'
			>
				<LayoutGroup>
					<AnimatePresence mode='popLayout'>
						{toasts.toReversed().map((toast, i) => (
							<motion.div
								key={toast.id}
								layout='position'
								style={{ zIndex: toasts.length - i }}
								initial={{ x: 80, opacity: 0 }}
								animate={{ x: 0, opacity: 1 }}
								exit={{ opacity: 0, transition: { duration: 0.1 } }}
								transition={{
									default: { type: 'spring', duration: 0.5 },
									opacity: { ease: 'linear', duration: 0.2 },
									layout: { type: 'spring', duration: 0.3, bounce: 0.4 },
								}}
								className={clsx(
									'pointer-events-auto',
									// The following lets the user scroll the toast stack even if their cursor isn't directly over a toast.
									// It expands the "hit area" of each toast to include a 4px border around it.
									"relative before:absolute before:top-1/2 before:left-1/2 before:h-[calc(100%+8px)] before:w-[calc(100%+8px)] before:-translate-1/2 before:content-['']",
								)}
							>
								{toast.renderContents()}
							</motion.div>
						))}
					</AnimatePresence>
				</LayoutGroup>
			</motion.div>
		</div>
	);
}
